import { ExternalLink } from "lucide-react";
import { salesforceRecordUrl, type SalesforceObject } from "../utils/salesforceLinks";

interface SalesforceRecordLinkProps {
  object: SalesforceObject;
  recordId: string;
  /** Visible text; defaults to the record id in monospace. */
  label?: string;
  children?: never;
}

/** Opens the Salesforce record in a new tab; shows the id in monospace with an external-link mark. */
export function SalesforceRecordLink({ object, recordId, label }: SalesforceRecordLinkProps) {
  return (
    <a
      href={salesforceRecordUrl(object, recordId)}
      target="_blank"
      rel="noopener noreferrer"
      title={`Open ${object} ${recordId} in Salesforce (new tab)`}
      className="inline-flex items-center gap-1 rounded font-mono text-xs text-brand-navy underline-offset-2 hover:underline focus:outline-none focus:ring-2 focus:ring-brand-green-50"
    >
      {label ?? recordId}
      <ExternalLink size={12} aria-hidden="true" />
      <span className="sr-only">(opens in Salesforce)</span>
    </a>
  );
}
